import axios from 'axios'
import IP from '@/common/ip'
import QS from 'qs'

let api_root = '/LockWeb/v1'

const httpInstance = axios.create({
  baseURL: IP.MediumIp
});

const apiMedium = {
  // 取消录入
  cancelMediumInfo: (params, config) => {
    return fetch('/medium/cancel', params, config)
  },
  // 读取介质
  getMediumInfo: (params, config) => {
    return fetch('/medium/read', params, config)
  },
}

const procData = (data, cb, err) => {
  let tmpCode = data.code.toString()
  switch (tmpCode) {
    case '200':
      cb(data.result)
      break
    default:
      err(data.message)
  }
}

const fetch = (url, params, config) => {
  let c = config || ''
  let v = api_root + url
  // 把json格式转成键值对
  let urlencoded = QS.stringify(params)

  return httpInstance.post(v, urlencoded, c).then((res) => {
    return {
      res: res.data,
      procData: procData
    }
  })
}

export default apiMedium